<template>
 <admin-header></admin-header>
 <admin-sidebar></admin-sidebar>
  <div class="page-wrapper">
    <div class="content pb-0 me-4">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Tabler Icon</h3>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <div class="row">
        <!-- Icons -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Tabler Icons</div>
            </div>
            <div class="card-body">
              <p class="mb-2">
                <code>&lt;i class="ti ti-ICON_NAME"&gt;&lt;/i&gt;</code>. For more
                information
                <a href="https://tabler-icons.io/" target="_blank" class="text-primary"
                  >click here</a
                >.
              </p>
              <div class="icons-items">
                <div class="icons-list">
                  <div class="icons-list-item">
                    <i class="ti ti-home" data-bs-toggle="tooltip" title="ti ti-home"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-layout-dashboard"
                      data-bs-toggle="tooltip"
                      title="ti ti-layout-dashboard"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-map-pin-check"
                      data-bs-toggle="tooltip"
                      title="ti ti-map-pin-check"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-message-2"
                      data-bs-toggle="tooltip"
                      title="ti ti-message-2"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-user-circle"
                      data-bs-toggle="tooltip"
                      title="ti ti-user-circle"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-photo"
                      data-bs-toggle="tooltip"
                      title="ti ti-photo"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-file-description"
                      data-bs-toggle="tooltip"
                      title="ti ti-file-description"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-chart-line"
                      data-bs-toggle="tooltip"
                      title="ti ti-chart-line"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-exchange"
                      data-bs-toggle="tooltip"
                      title="ti ti-exchange"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-menu-2"
                      data-bs-toggle="tooltip"
                      title="ti ti-menu-2"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-settings-cog"
                      data-bs-toggle="tooltip"
                      title="ti ti-settings-cog"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-activity"
                      data-bs-toggle="tooltip"
                      title="ti ti-activity"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-shopping-bag"
                      data-bs-toggle="tooltip"
                      title="ti ti-shopping-bag"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-brand-hipchat"
                      data-bs-toggle="tooltip"
                      title="ti ti-brand-hipchat"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i class="ti ti-bell" data-bs-toggle="tooltip" title="ti ti-bell"></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-mail-cog"
                      data-bs-toggle="tooltip"
                      title="ti ti-mail-cog"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-location"
                      data-bs-toggle="tooltip"
                      title="ti ti-location"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-chart-pie"
                      data-bs-toggle="tooltip"
                      title="ti ti-chart-pie"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-checkbox"
                      data-bs-toggle="tooltip"
                      title="ti ti-checkbox"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-checks"
                      data-bs-toggle="tooltip"
                      title="ti ti-checks"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-chevron-down"
                      data-bs-toggle="tooltip"
                      title="ti ti-chevron-down"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-chevrons-right"
                      data-bs-toggle="tooltip"
                      title="ti ti-chevrons-right"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-circle-arrow-right-filled"
                      data-bs-toggle="tooltip"
                      title="ti ti-circle-arrow-right-filled"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-cloud-download"
                      data-bs-toggle="tooltip"
                      title="ti ti-cloud-download"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-database"
                      data-bs-toggle="tooltip"
                      title="ti ti-database"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-device-analytics"
                      data-bs-toggle="tooltip"
                      title="ti ti-device-analytics"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-discount"
                      data-bs-toggle="tooltip"
                      title="ti ti-discount"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-dots-vertical"
                      data-bs-toggle="tooltip"
                      title="ti ti-dots-vertical"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-download"
                      data-bs-toggle="tooltip"
                      title="ti ti-download"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-trash"
                      data-bs-toggle="tooltip"
                      title="ti ti-trash"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-folder-open"
                      data-bs-toggle="tooltip"
                      title="ti ti-folder-open"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-calendar"
                      data-bs-toggle="tooltip"
                      title="ti ti-calendar"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-calculator"
                      data-bs-toggle="tooltip"
                      title="ti ti-calculator"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-clock"
                      data-bs-toggle="tooltip"
                      title="ti ti-clock"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-phone-call"
                      data-bs-toggle="tooltip"
                      title="ti ti-phone-call"
                    ></i>
                  </div>

                  <div class="icons-list-item">
                    <i
                      class="ti ti-video"
                      data-bs-toggle="tooltip"
                      title="ti ti-video"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /icons -->
      </div>
    </div>

    <!-- Footer-->
    <div class="footer d-sm-flex align-items-center justify-content-between bg-white p-3">
      <p class="mb-0">
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);" class="ms-4">Terms of Use</a>
      </p>
      <p>
        &copy; 2025 Dreamsrent, Made with <span class="text-danger">❤</span> by
        <a href="javascript:void(0);" class="text-secondary">Dreams</a>
      </p>
    </div>
    <!-- /Footer-->
  </div>
</template>
